// Единая точка работы с токеном сессии.
//
// В браузере токен живёт в localStorage. Когда фронтенд открыт как мини-апп
// в Telegram, localStorage может затираться между сессиями, поэтому токен
// дублируется в Telegram CloudStorage (если оно доступно) и при старте
// восстанавливается из него (restoreToken()).
//
// Чтение (getToken) — синхронное: весь существующий код продолжает работать
// как раньше. В браузере CloudStorage недоступно и все операции вырождаются
// в обычную работу с localStorage.
const TOKEN_KEY = "token";
const CLOUD_RESTORE_TIMEOUT_MS = 3000;

const cloudStorage = () => {
  try {
    const storage = window.Telegram?.WebApp?.CloudStorage;
    if (
      storage &&
      typeof storage.getItem === "function" &&
      typeof storage.setItem === "function" &&
      typeof storage.removeItem === "function"
    ) {
      return storage;
    }
  } catch {}
  return null;
};

const cloudCall = (method, args = []) => {
  const storage = cloudStorage();
  if (!storage) {
    return;
  }
  try {
    storage[method](...args);
  } catch {}
};

export const getToken = () => {
  try {
    return localStorage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
};

export const saveToken = (token) => {
  try {
    localStorage.setItem(TOKEN_KEY, token);
  } catch {}
  cloudCall("setItem", [TOKEN_KEY, token]);
};

export const clearToken = () => {
  try {
    localStorage.removeItem(TOKEN_KEY);
  } catch {}
  cloudCall("removeItem", [TOKEN_KEY]);
};

const cloudGetItem = (storage, key) =>
  new Promise((resolve) => {
    const timer = setTimeout(() => resolve(null), CLOUD_RESTORE_TIMEOUT_MS);
    try {
      storage.getItem(key, (err, value) => {
        clearTimeout(timer);
        resolve(err || typeof value !== "string" ? null : value);
      });
    } catch {
      clearTimeout(timer);
      resolve(null);
    }
  });

// Один раз при старте приложения до рендера: если localStorage пуст, а в
// CloudStorage токен остался — возвращаем его в localStorage. В браузере
// завершается сразу (CloudStorage недоступно, токен восстанавливать неоткуда).
export const restoreToken = async () => {
  const local = getToken();
  if (local) {
    return local;
  }
  const storage = cloudStorage();
  if (!storage) {
    return null;
  }
  const value = await cloudGetItem(storage, TOKEN_KEY);
  if (value) {
    try {
      localStorage.setItem(TOKEN_KEY, value);
    } catch {}
  }
  return value;
};
